import { enGB_menu } from './menu'
import { enGB_system } from './sys'

const en_GB = {
	...enGB_menu,
	...enGB_system
}

export default en_GB
